import { formTypes } from "../../../constants";
import { getAllData } from "../../../utils/helpers/fetching";
import { getQueryAndFilter, extractVariables, getUpdatedItems } from "./fetch-common-helpers";

export const fetchCommon =
  ({
    queryAsc,
    queryDesc,
    queryWithInstrumentAsc,
    runQueryWithInstrumentDesc,
    runQueryName,
    actionQueryWithInstrumentDesc,
    actionQueryName
  }) =>
    async ({
      client,
      sortDirection,
      equipmentModel,
      signee,
      instrument,
      dateFrom,
      dateTo,
      storeUser,
      limit,
      nextToken,
      drillData = false,
      inventoryId,
      logType,
      signeeList
    }) => {
      const { query, filter } = getQueryAndFilter({
        equipmentModel,
        signee,
        sortDirection,
        queryDesc,
        queryAsc,
        instrument,
        dateFrom,
        dateTo,
        queryWithInstrumentDesc:
          logType === formTypes.RUN_LOG ? runQueryWithInstrumentDesc : actionQueryWithInstrumentDesc,
        queryWithInstrumentAsc,
        inventoryId,
        logType,
        signeeList
      });
      const { token, items } = await getAllData({
        client,
        query,
        dataPath: ["data", logType === formTypes.RUN_LOG ? runQueryName : actionQueryName],
        variables: extractVariables({
          instrument,
          dateFrom,
          dateTo,
          storeUser,
          limit,
          nextToken,
          filter,
          inventoryId
        }),
        drillData
      });

      // const runItems = items.map((object) => {
      //   return { ...object, logType: "Run" };
      // });

      // const actionItems = items1.map((object) => {
      //   return { ...object, logType: "Action" };
      // });

      /* Merge Run and Action time */

      const updatedItems = getUpdatedItems(items);

      if (logType === formTypes.RUN_LOG) {
        return {
          runItems: updatedItems,
          runToken: token
        };
      } else {
        return {
          actionItems: updatedItems,
          actionToken: token
        };
      }
    };
